import React, { useEffect, useMemo, useState } from 'react';
import { $ } from 'react-jquery-plugin';
import { Link, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import Countdown from 'react-countdown';
import { shuffleArray } from '../../common-helper';
import { toast } from 'react-toastify';
import { useImages } from '../ImageContext';

const Level1 = () => {
  const navigate = useNavigate();
  const [level] = useState(1);
  const [total, setTotal] = useState(0.0);
  const [timerValue, setTimerValue] = useState('0:0:0');
  const [clicks, setClicks] = useState(2);
//   const initialImages = [
//     'assets/images/circles/img1.svg',
//     'assets/images/circles/img2.svg',
//     'assets/images/circles/img3.svg',
//     'assets/images/circles/img4.svg',
//     'assets/images/circles/img5.svg',
//     'assets/images/circles/img6.svg',
//     'assets/images/circles/img7.svg',
//     'assets/images/circles/img8.svg',
//     'assets/images/circles/img9.svg',
//     'assets/images/circles/img10.svg',
//     'assets/images/circles/img11.svg',
//     'assets/images/circles/img12.svg',
//     'assets/images/circles/img13.svg',
//     'assets/images/circles/img14.svg',
//     'assets/images/circles/img15.svg',
//     'assets/images/circles/img16.svg',
//     'assets/images/circles/img17.svg',
//     'assets/images/circles/img18.svg',
//     'assets/images/circles/img19.svg',
//     'assets/images/circles/img20.svg',
//   ];
//   const [images, setImages] = useState(shuffleArray([...initialImages]));
  const initialImages = useImages();
  const images = useMemo(() => shuffleArray([...initialImages]), [initialImages]);
  const [currentImageIndex, setCurrentImageIndex] = useState([]);

  const timer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      navigate('/level-2');
    } else {
      const tt = hours * 60 * 60 + minutes * 60 + seconds;
      localStorage.setItem('timetakenl1', tt);
      return <span>{hours}:{minutes}:{seconds}</span>;
    }
  };

  useEffect(() => {
    const randomNumbers = [];
    if (level === 1) {
      for (let i = 0; i < 2; i++) {
        let randNum = Math.floor(Math.random() * initialImages.length);
        while (randomNumbers.includes(randNum)) {
          randNum = Math.floor(Math.random() * initialImages.length);
        }
        randomNumbers.push(randNum);
      }
    }
    setCurrentImageIndex(randomNumbers);
  }, [level, initialImages]);

  const handleStartGame = (e) => {
    e.preventDefault();
    $('.rememberMatch').hide();
    $('.findMatch').show();
    setTimerValue(<Countdown date={Date.now() + 30000} renderer={timer} />);
  };

  const handleMatchObject = (item) => {
    if (clicks > 0) {
      for (let i = 0; i < currentImageIndex.length; i++) {
        if (images[currentImageIndex[i]] === item) {
          const getscore = parseFloat(total) + 5;
          setTotal(getscore);
          const correctAns = localStorage.getItem('level1');
          localStorage.setItem('level1', parseInt(correctAns) + 1);
          currentImageIndex.splice(i, 1);
          $(`.level1 img[src='${item}']`).addClass('correct-ans').removeClass('wrong-ans');
          toast.success('Correct answer.');
          setClicks(clicks - 1);
        } else {
          toast.warning('Wrong answer.');
          $(`.level1 img[src='${item}']`).addClass('wrong-ans').removeClass('correct-ans');
          setClicks(clicks - 1);
        }
      }
    } else {
      toast.warning('You are out of clicks, Click continue to next level.');
    }
  };

  return (
    <>
      <section className="sec-gamification">
        <div className="container">
          <div className="row">
            <div className="col-md-12 p-0">
              <div className="gamification-dv">
                <div className="srceen srceen3 rememberMatch">
                  <div className="lavel lavel-start">
                    <div className="lavel-num"><span>{level}</span>Level</div>
                    <div className="score-numbg">
                      <div className="score-num">
                        <span>
                          <img src="assets/images/star-score-icon.svg" className="img-fluid" alt="Score" />
                          Score
                        </span> {total.toFixed(1)}
                      </div>
                      <div className="score-total"><span>Total Score</span> 10</div>
                    </div>
                    <div className="time-clock">
                      <span>
                        <img src="assets/images/clock-icon.svg" className="img-fluid" alt="Clock" />
                      </span>
                      0:0:30
                    </div>
                  </div>
                  <div className="texthd2">
                    <div className="texthdTx">
                      <h1>Level {level}</h1>
                      <h2>Let’s test your memory</h2>
                      <div className="gamebgcl">
                        <div className="gamebgclb1">
                          {currentImageIndex.map((item, index) => (
                            <div id={index} className="lavel-img3 hoverable" key={index}>
                              <img src={images[item]} className="img-fluid" alt="" />
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="text-center">
                        <Link to="#" className="get-started btnv2" onClick={handleStartGame}>Continue</Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="srceen srceen6 findMatch" style={{ display: 'none' }}>
                  <div className="lavel lavel-start">
                    <div className="lavel-num"><span>{level}</span>Level</div>
                    <div className="score-numbg">
                      <div className="score-num">
                        <span>
                          <img src="assets/images/star-score-icon.svg" className="img-fluid" alt="Score" /> Score
                        </span> <span id="score">{total.toFixed(1)}</span>
                      </div>
                      <div className="score-total"><span>Total Score</span> 10</div>
                    </div>
                    <div className="time-clock">
                      <span>
                        <img src="assets/images/clock-icon.svg" className="img-fluid" alt="Clock" />
                      </span>
                      <span id="countdown">{timerValue}</span>
                    </div>
                  </div>
                  <div className="texthd2">
                    <div className="texthdTx">
                      <h2>Find the right blocks</h2>
                      <div className="gamebgcl">
                        <div className="gamebgclb3 level1">
                          {images.map((clickImages, index) => (
                            <div id={index} className="lavel-img3 hoverable" key={index} data={clickImages} onClick={() => handleMatchObject(clickImages)}>
                              <img src={clickImages} className="img-fluid" alt="" />
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="text-center">
                        <Link to="/level-2" className="get-started btnv5">Continue</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Level1;
